export default __webpack_public_path__ + "static/media/polska.f381a668.jpg";